// --- UPDATED FILE: packages/components/src/admin/AdminHeader.tsx ---

import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon } from '@dopomogai/ui';
import type { UserDB } from '@dopomogai/types';

interface AdminHeaderProps {
  user: UserDB;
  onSignOut: () => void;
}

export const AdminHeader: React.FC<AdminHeaderProps> = ({ user, onSignOut }) => {
  const userName = user.name || user.email?.split('@')[0] || 'Admin';

  return (
    <header className="h-20 flex-shrink-0 bg-white border-b border-slate-200 flex items-center justify-between px-8">
      {/* The title is removed to give more focus to the page content's title */}
      <div/>
      <div className="flex items-center gap-4">
        <span className="text-sm font-medium text-slate-600">
          Welcome, <span className="font-bold">{userName}</span>
        </span>
        <div className="h-8 w-px bg-slate-200" />
        <Button asChild variant="outline" size="sm" icon="ExternalLink">
            <Link to="/" target="_blank" rel="noopener noreferrer">View Public Site</Link>
        </Button>
        <Button onClick={onSignOut} variant="secondary" size="sm" icon="LogOut">
          Sign Out
        </Button>
      </div>
    </header>
  );
};